import { useLayoutEffect, useRef } from 'react';
import { ensureIntersectionObserver } from '@src/utils/intersectionObserverPromise';
const intersectionObserverPromise = (callback, options) => {
    return ensureIntersectionObserver().then(() => {
        const { root, threshold } = options || {};
        const observerSettings = {
            root: root || null,
            threshold: threshold || [
                0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1,
            ],
        };
        const observer = new IntersectionObserver(callback, observerSettings);
        return Promise.resolve(observer);
    });
};
export const useIntersectionObserver = ({ callback, element, options, disabled = false, }) => {
    const observer = useRef(undefined);
    useLayoutEffect(() => {
        var _a;
        if (!disabled && element) {
            (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
            intersectionObserverPromise(callback, options).then((o) => {
                observer.current = o;
                observer.current.observe(element);
            });
        }
        return () => { var _a; return (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect(); };
    }, [callback, element, options, disabled]);
};
